/* eslint-disable no-console */
import { PROD } from 'config/environments';

const consoleLogger = (error, context) => {
  if (process.env.SPA_ENV !== PROD) {
    console.error(error, context);
  }
};

export default consoleLogger;
